import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useIntl } from "react-intl";
import { ReactComponent as Globe05 } from "assets/images/iconsV2/globe-05.svg";

import "./MissingGeolocationIndicator.scss";

export default function MissingGeolocationIndicator() {
  const intl = useIntl();
  const label = intl.formatMessage({
    id: "settings.address-book.missingGeolocation",
    defaultMessage: "Missing geolocation",
  });

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id="missing-geolocation-tooltip">{label}</Tooltip>}>
      <div
        className="missing-geolocation-indicator"
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
        role="img"
        aria-label={label}
      >
        <Globe05 className="missing-geolocation-indicator__icon" />
      </div>
    </OverlayTrigger>
  );
}
